<template>
    <div>
        <div class="block-container">
            <div class="content-caption dashed bg-white">
                <span>工单基本信息</span>
            </div>
            <div class="column-layout flex">
                <div class="form-info">
                    <div class="form-row col col-6 fl">
                        <div class="form-label">
                            <label>单号：</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.no}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label">
                            <label>状态：</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.stateText}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label">
                            <label>客户名称：</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.buyerName}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label">
                            <label>客户机构：</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.buyerShopName}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label">
                            <label>服务：</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.servcTitle}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-container">
                <div class="content-caption dashed bg-white">
                    <span>服务商信息</span>
                    <a class="swb-btn-link" @click="selectServicer()">选择</a>
                    <a class="swb-btn-link" @click="assignSelf()" v-if="viewAsginThis">指给自己</a>
                </div>
                <el-table :data="authServicerList" style="width: 100%" border>
                    <el-table-column prop="servicerName" label="名称"></el-table-column>
                    <el-table-column prop="dateStart" label="开始时间"></el-table-column>
                    <el-table-column prop="dateEnd" label="截止时间"></el-table-column>
                </el-table>
                <div class="content-caption dashed bg-white">
                    <span>网点信息</span>
                    <a class="swb-btn-link" @click="selectServicerShop()">选择</a>
                </div>
                <el-table :data="servicerComList" style="width: 100%" border>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="address" label="地址"></el-table-column>
                    <el-table-column prop="contactName" label="联系人"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import servcDelivApi from '../../api/servcDeliv'
    import servicerApi from '../../api/servicer'
    import userApi from '../../api/user'
    import { openAuthServicerForSelectDlg } from '../servicer/selectDlg'
    import { openServicerComTreeSelectDlg } from '../orgStruct/selectDlg';
    import SwbServcWorkVoucherDispatchShopSelect from '../workVoucher/ServcWorkVoucherDispatchShopSelect';
    Vue.regist(SwbServcWorkVoucherDispatchShopSelect);
    //
    export default {
        name: 'swb-servc-work-voucher-servicer',
        desc: '更换服务商',
        props: ["id", "viewAsginThis"],
        data: function () {
            return {
                servcWorkVoucher: {},
                authServicerList: [],
                servicerComList: [],
                servicerId: null,
                servicerShopId: null,
                scopeEntity: {}
            }
        },
        created: function () {
            this.getCurrentUserInfo();
            this.getServcWorkVoucher(this.id);
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                    }
                });
            },
            getServcWorkVoucher: function (id) {
                let self = this;
                let scopeEntity = self.scopeEntity;
                let params = {};
                params.id = id;
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    if(result.type === "info") {
                        let servcWorkVoucher = result.data;
                        if(!Utils.isNoB(servcWorkVoucher) && servcWorkVoucher.id > 0) {
                            //
                            let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                            if(servcWorkVoucher.closed) {
                                servcWorkVoucher.stateText = '已关闭';
                            } else if(servcWorkVoucher.invalid) {
                                servcWorkVoucher.stateText = '已作废';
                            } else if(stateInfo != null) {
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        self.servicerId = servcWorkVoucher.servicerId;
                        self.servicerShopId = servcWorkVoucher.servicerShopId;
                        self.servcWorkVoucher = servcWorkVoucher;
                        if(!Utils.isNoB(servcWorkVoucher.servicerId)) {
                            if(scopeEntity.id == servcWorkVoucher.servicerId) {
                                let authServicerList = [];
                                let authServicer = {};
                                authServicer.servicerName = scopeEntity.name;
                                authServicerList.push(authServicer);
                                self.authServicerList = Utils.merge([], authServicerList)
                            } else {
                                self.getServicer();
                            }

                        }
                        if(!Utils.isNoB(servcWorkVoucher.servicerShopId)) {
                            self.getServicerShop();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getServicer: function () {
                let self = this;
                let postData = {
                    servicerId: self.servicerId,
                };
                let authServicerList = []
                servicerApi.getAuthServicerInfoByServicerId(postData, function (result) {
                    if(result.type == "info") {
                        let authServicer = result.data;
                        authServicerList.push(authServicer);
                        self.authServicerList = Utils.merge([], authServicerList)
                    }
                })
            },
            getServicerShop: function () {
                let self = this;
                let postData = {
                    comId: self.servicerShopId
                };
                let servicerComList = [];
                servicerApi.getServicerCom(postData, function (result) {
                    if(result.type == "info") {
                        let servicerCom = result.data;
                        let regionName = servicerCom.regionName;
                        let address = regionName;
                        if(!Utils.isNoB(servicerCom.street)) {
                            address = regionName + servicerCom.street;
                        }
                        servicerCom.address = address;
                        servicerComList.push(servicerCom);
                        self.servicerComList = Utils.merge([], servicerComList);
                    }
                })
            },
            selectServicer: function () {
                let self = this;
                let authServicerList = [];
                let servcWorkVoucher = self.servcWorkVoucher;
                let ssuId = servcWorkVoucher.ssuId;
                openAuthServicerForSelectDlg({multiSelect: false, ssuId: ssuId}, function (result) {
                    let authServicer = result;
                    if(self.servicerId != authServicer.servicerId) {
                        authServicerList.push(authServicer);
                        self.authServicerList = Utils.merge([], authServicerList);
                        self.servicerComList = Utils.merge([]);
                        self.servicerId = authServicer.servicerId;
                        self.servicerShopId = null;
                    } else {
                        MsgBox.warning("此服务商与原来服务商相同");
                        return false;
                    }
                })
            },
            assignSelf: function () {
                let self = this;
                let scopeEntity = this.scopeEntity;
                //
                let authServicerList = [];
                let authServicer = {};
                authServicer.servicerName = scopeEntity.name;
                authServicerList.push(authServicer);
                self.authServicerList = Utils.merge([], authServicerList);
                self.servicerComList = Utils.merge([]);
                self.servicerId = scopeEntity.id;
                self.servicerShopId = null;
            },
            selectServicerShop: function () {
                let self = this;
                let servcWorkVoucher = this.servcWorkVoucher;
                let buyerShopLng = servcWorkVoucher.requestLng;
                let buyerShopLat = servcWorkVoucher.requestLat;
                if(buyerShopLng == null || buyerShopLat == null) {
                    buyerShopLng = servcWorkVoucher.buyerShopLng;
                    buyerShopLat = servcWorkVoucher.buyerShopLat;
                }
                if(buyerShopLng == null || buyerShopLat == null) {
                    buyerShopLng = servcWorkVoucher.deviceLng;
                    buyerShopLat = servcWorkVoucher.deviceLat;
                }
                if(buyerShopLng == null || buyerShopLat == null) {
                    buyerShopLng = -1;
                    buyerShopLat = -1;
                }
                //
                let servicerId = self.servicerId;
                let servicerShopId = self.servicerShopId;
                let servicerComList = [];
                let theDlg = Vue.$showDialog({
                    title: '工单 - 机构调度',
                    width: 1200,
                    height: 750,
                    showCloseBtn: true,
                    //okVisible: true,
                    // cancelText: "关闭",
                    template: '<div class = "">' +
                    '<swb-servc-work-voucher-dispatch-shop-select :merchantId="merchantId" :buyerShopLat="buyerShopLat" :buyerShopLng="buyerShopLng" :servcId="servcId" :servcType="servcType" :buyerShopId="buyerShopId" :devcCatId="devcCatId" :servcCatId="servcCatId" ref="swb_servc_work_voucher_dispatch_shop_select"></swb-servc-work-voucher-dispatch-shop-select>' +
                    '</div>',
                    data: {
                        merchantId: servicerId,
                        buyerShopLat: buyerShopLat,
                        buyerShopLng: buyerShopLng,
                        servcId: servcWorkVoucher.servcId,
                        servcType: servcWorkVoucher.servcType,
                        buyerShopId: servcWorkVoucher.buyerShopId,
                        devcCatId: servcWorkVoucher.devcCatId,
                        servcCatId: servcWorkVoucher.servcCatId
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDef = this;
                        let servicerCom = selfDef.$refs.swb_servc_work_voucher_dispatch_shop_select.getDlgResult() || {};
                        //
                        if(servicerCom != null && servicerCom.id != null) {
                            if(servicerShopId == servicerCom.id) {
                                MsgBox.warning("所选机构是本机构，不可重复调度！");
                                return;
                            }
                            if(!servicerCom.shopFlag) {
                                MsgBox.warning("所选机构不是网点！");
                                return;
                            }
                            self.servicerShopId = servicerCom.id;
                            let regionName = servicerCom.regionName;
                            let address = regionName;
                            if(!Utils.isNoB(servicerCom.street)) {
                                address = regionName + servicerCom.street;
                            }
                            servicerCom.address = address;
                            servicerComList.push(servicerCom);
                            self.servicerComList = Utils.merge([], servicerComList);
                        } else {
                            self.$message.warning("请选择网点");
                        }
                        return true;
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let servcWorkVoucher = self.servcWorkVoucher;
                if(Utils.isNoB(self.servicerId)) {
                    result.message = "请选择服务商信息";
                    result.type == "warn";
                    return result;
                }
                if(!Utils.isNoB(servcWorkVoucher.servicerShopId) && servcWorkVoucher.servicerShopId == self.servicerShopId) {
                    result.message = "未更换信息";
                    result.type == "warn";
                    return result;
                }
                let postData = {};
                postData.servicerShopId = self.servicerShopId;
                postData.servicerId = self.servicerId;
                result.data = postData;
                result.type = "info";

                return result;
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/rentServc/ServcWorkVoucherDispatch.vue